
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import customModal from "../customModal/customModal.vue";
import jwt_decode from "jwt-decode";
import Multiselect from "@vueform/multiselect";
export default {
  components: {
    customModal,
    Multiselect
  },
  name: "CreateSchedulePopup",
  props: {
    siteId: {

      type: String,

      default: ""

    },
    sitecode: {

      type: String,

      default: ""

    }
  },
  data() {
    return {
 
      baseapi: process.env.VUE_APP_Service_URL,
      roleList:[],
      userList:[],
      checklists: [],
      kpiWithScores: [],
      openModal: false,
       scheduleForm: {
        siteCode: '',
        plannedDate: '',
        immediateDate: null,
        overridePlannedDate: false,
        craVisitType: "Unscheduled Visit",
        monitoringMode: '',
        triggeredBy: '',
        triggeredByComment: '',
        visitName: '',
        craid: '',
        status: '',
        checklist: [],
        headers:{},
      },
      monitoringModeOptions: ['Onsite', 'Remote', 'Hybrid', 'Central'],
      triggeredByOptions: ['Protocol Scheduled', 'Risk Signal Detected', 'Major Protocol Deviation', 'High Query Rate', 'High AE Rate', 'Missed Visit', 'Manual Assignment', 'Regulatory Requirement','Others'],
    };
  },
  async mounted() {
    const idtoken = store.getters.getIdToken;
    this.useremail = jwt_decode(idtoken).email;
    this.headers = {
      headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      },
    };
     this.scheduleForm.siteCode = this.sitecode;
     this.onVisitTypeChange();
     await this.setRoleList();
     await this.onRoleChange();
    

  },
  methods: {
    closescheduleModal() {
      this.$emit("closescheduleModal");
    },
    async onVisitTypeChange() {
     this.scheduleForm.checklist = [];

      const idtoken = store.getters.getIdToken;
      this.checklists = [];

      if (!this.scheduleForm.craVisitType) return;

      const res = await axios.get(
        `${this.baseapi}/forms/cra/getchecklistbyvisit`,
        {
          params: { visittype: this.scheduleForm.craVisitType },
          headers: { Authorization: `Bearer ${idtoken}` }
        }
      );

      this.checklists = (res.data?.checklist || []).map(item => ({
    value: item.checklistId,
    label: item.title,
    questions: item.questions
  }));
    },
    async setRoleList() {
      const res = await axios.get(
        `${this.baseapi}/account-core/roles/rolelist`,
        this.headers
      );
      this.roleList = res.data || [];
    },
    craRoleId() {
      const craRole = this.roleList.find(
        r => r.roleName?.toUpperCase() === "CRA"
      );
      return craRole?.roleID || "";
    },
    async onRoleChange() {
  const craRoleId = this.craRoleId();
  if (!craRoleId) {
    console.warn("CRA role not found");
    return;
  }
console.log("craRoleId is",craRoleId);
  const currentstudyid = store.getters.getStudyIs;

  const res = await axios.get(
    `${this.baseapi}/account-core/user/getusersbyrole`,
    {
      params: {
        roleids: craRoleId,
        studyid: currentstudyid
      },
      headers: {
        Authorization: this.headers.headers.Authorization
      }
    }
  );

  this.userList = res.data || [];
},
submitSchedule() {
    if (!this.validateForm()) {
        return;
      }

      const currentstudyid = store.getters.getStudyIs;
      const studyname = store.getters.getStudyIs;

      const payload = {
        studyId: currentstudyid,
        craId: this.scheduleForm.craid,
        studyName: studyname,
        siteId: this.siteId,
        siteCode: this.scheduleForm.siteCode,
        plannedDate: new Date(this.scheduleForm.plannedDate).toISOString(),
        immediateDate: null,
        overridePlannedDate: false,
        craVisitType: this.scheduleForm.craVisitType,
        visitName: this.scheduleForm.visitName,
        monitoringMode: this.scheduleForm.monitoringMode,
        reason: this.scheduleForm.triggeredBy,
        comments: this.scheduleForm.triggeredBy === 'Others' ? this.scheduleForm.triggeredByComment : '',
        status: this.scheduleForm.status,
        checklist: this.scheduleForm.checklist

      };

      // Make API call
      axios.post(`${this.baseapi}/forms/cra/craschedulecreate`, payload, this.headers)
        .then((res) => {
          console.log('Schedule Created Successfully:', res.data);
          alert('CRA Schedule created successfully');
          this.closeScheduleModal();
          this.closeRisksModal();
          // Optionally refresh the KPI list
          this.getOverdueVisitslist();
        })
        .catch((err) => {
          console.error('Error creating schedule:', err);
          alert('Error creating CRA Schedule. Please try again.');
        })
    },

  },
};